// This file can be replaced during build by using the `fileReplacements` array.
// The list of file replacements can be found in `angular.json`.

declare const APP_CONFIG: AppConfig;

import moment from 'moment';
import { AppConfig } from './app.config';

APP_CONFIG.lastBuild ??= moment().format('MM-DD-YYYY HH:mm:ss Z');
APP_CONFIG.version ??= moment().unix()?.toString();

export const environment = {
  productionMode: false,
  intercomAppId: 'khnaz0xy',
  baseUrl: APP_CONFIG.baseUrl || 'http://localhost/api'
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

